import { CMSTable } from "../../component/CMSTable";

export default function CMSPage() {
  return <CMSTable />;
}
